import {
  reduxKey,
  groupFoldersStreamType,
  groupsStreamType,
  recommendedGroupsStreamType,
} from './constants';
import {
  PapiDeviation,
  PapiUser,
  PapiDaDeviationGroupAdd,
} from '@wix/da-papi-types';

export enum FolderType {
  Collection = 'collection',
  Gallery = 'gallery',
}

export interface GroupsStreamParams {
  type: typeof groupsStreamType;
  userId: number;
}

export interface GroupFolderStreamParams {
  type: typeof groupFoldersStreamType;
  userId: number;
  groupId: number;
  folderType: FolderType;
}

export interface RecommendedGroupsStreamParams {
  type: typeof recommendedGroupsStreamType;
}

export interface GroupFolderId {
  groupId: number;
  type: FolderType;
  folderId: number;
}

export interface PapiDaDeviationGroupAddOrError
  extends PapiDaDeviationGroupAdd {
  // Allows getting better reasons for why an add failed
  // from group_deviation_module.php
  errorDetails?: string;
}

export interface GroupAddedNotificationParams {
  success: boolean;
  error?: string;
  needsVote?: boolean;
  deviation: PapiDeviation;
  group: PapiUser;
  groupFolderId: GroupFolderId;
  actionbarType?: string;
}

export interface AddToGroupFolderState {
  loading: boolean;
  added: boolean;
  suggested: boolean;
}

export interface AddToGroupsPanelState {
  [k: string]: AddToGroupFolderState;
}

export interface AddToGroupsPanelStoreSlice {
  [reduxKey]?: AddToGroupsPanelState;
}
